import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminBlogForm.css';
import { Slidar } from '../AdminDashbord/Slidar';
import { FaEdit } from "react-icons/fa";
import { MdAutoDelete } from "react-icons/md";

const AdminSellsForm = () => {
  const [title, setTitle] = useState('');
  const [caption, setCaption] = useState('');
  const [description, setDescription] = useState('');
  const [subParts, setSubParts] = useState(['']);
  const [image, setImage] = useState(null);
  const [extraImages, setExtraImages] = useState([]);
  const [sells, setSells] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [expandedIds, setExpandedIds] = useState([]);

  useEffect(() => {
    fetchSells();
  }, []);

  const fetchSells = async () => {
    const res = await axios.get('/api/Sells');
    setSells(res.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('caption', caption);
    formData.append('description', description);
    formData.append('subParts', JSON.stringify(subParts));

    if (image) formData.append('image', image);
    extraImages.forEach(file => file && formData.append('extraImages', file));

    try {
      if (editId) {
        await axios.put(`/api/Sells/${editId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        alert('✅ Sell updated successfully!');
      } else {
        await axios.post('/api/Sells', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        alert('✅ Sell created successfully!');
      }

      // reset form
      setTitle('');
      setCaption('');
      setDescription('');
      setSubParts(['']);
      setImage(null);
      setExtraImages([]);
      setEditId(null);
      setShowForm(false);
      fetchSells();
    } catch (error) {
      console.error(error);
      alert('❌ Submission failed. Please try again.');
    }
  };

  const handleEdit = (sell) => {
    setTitle(sell.title);
    setCaption(sell.caption);
    setDescription(sell.description);
    setSubParts(sell.subParts);
    setEditId(sell._id);
    setShowForm(true);

    setImage(null);
    setExtraImages([]);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure to delete this sell?')) {
      await axios.delete(`/api/Sells/${id}`);
      fetchSells();
      alert('🗑️ Sell deleted');
    }
  };

  return (
    <>
      <div className="d-flex">
        <Slidar />
        <div className="blog-form-container-flex">
          <div className="blog-form-content">

            {/* Toggle Button */}
            <div>
              <button className="toggle-form-button" onClick={() => {
                setShowForm(!showForm);
                if (!showForm) {
                  setEditId(null);
                  setTitle('');
                  setCaption('');
                  setDescription('');
                  setSubParts(['']);
                  setImage(null);
                  setExtraImages([]);
                }
              }}>
                {showForm ? '❌ Close Form' : '➕ Add Product'}
              </button>
            </div>

            {showForm && (
              <>
                <h2>{editId ? '✏️ Edit Sell' : '📝 Add New Product'}</h2>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" required />
                  <input type="text" value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Caption" required />
                  <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Main Description" required />

                  {subParts.map((part, idx) => (
                    <textarea
                      key={idx}
                      value={part}
                      onChange={(e) => {
                        const updated = [...subParts];
                        updated[idx] = e.target.value;
                        setSubParts(updated);
                      }}
                      placeholder={`Subpart ${idx + 1}`}
                      required
                    />
                  ))}
                  <button type="button" onClick={() => setSubParts([...subParts, ''])}>➕ Add Subpart</button>

                  {/* Main Image */}
                  <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />

                  {/* Extra Images */}
                  {[0,1,2,3].map(idx => (
                    <input
                      key={idx}
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const files = [...extraImages];
                        files[idx] = e.target.files[0];
                        setExtraImages(files);
                      }}
                    />
                  ))}

                  <button type="submit">{editId ? '🔄 Update Product' : '🚀 Submit Product'}</button>
                </form>
              </>
            )}

            <h3 className='mt-2'>📚 Existing Products</h3>
            <div className="blog-list">
              {sells.map(sell => {
                const isDropdownOpen = dropdownOpenId === sell._id;
                const isExpanded = expandedIds.includes(sell._id);

                return (
                  <div key={sell._id} className="blog-card">
                    <button className="card-menu" onClick={() => setDropdownOpenId(isDropdownOpen ? null : sell._id)}>⋮</button>
                    {isDropdownOpen && (
                      <div className="card-dropdown">
                        <button onClick={() => handleEdit(sell)}><FaEdit color="black" /></button>
                        <button onClick={() => handleDelete(sell._id)}><MdAutoDelete color="black" /></button>
                      </div>
                    )}

                    <h4>{sell.title}</h4>
                    <p><strong>Caption:</strong> {sell.caption}</p>
                    <p>
                      <strong>Description:</strong> {isExpanded ? sell.description : `${sell.description.slice(0,50)}...`}
                    </p>

                    {sell.subParts?.length > 0 && (
                      <div>
                        <strong>SubParts:</strong>
                        <ul>
                          {sell.subParts.map((part, idx) => <li key={idx}>{part}</li>)}
                        </ul>
                      </div>
                    )}

                    {sell.description.length > 100 && (
                      <div style={{ marginTop: 'auto', textAlign: 'right' }}>
                        <button
                          style={{
                            backgroundColor: '#eee',
                            color: '#333',
                            fontSize: '12px',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            if (expandedIds.includes(sell._id)) {
                              setExpandedIds(expandedIds.filter(id => id !== sell._id));
                            } else {
                              setExpandedIds([...expandedIds, sell._id]);
                            }
                          }}
                        >
                          {isExpanded ? '🔼 Read Less' : '🔽 Read More'}
                        </button>
                      </div>
                    )}

                    {sell.imagePath && (
                      <img src={`/uploads/${sell.imagePath}`} alt="Main" style={{ width:"200px", marginBottom:"10px" }} />
                    )}

                    {sell.extraImages && sell.extraImages.length > 0 && (
                      <div style={{ display:"flex", gap:"10px", flexWrap:"wrap" }}>
                        {sell.extraImages.map((img, idx) => (
                          <img key={idx} src={`/uploads/${img}`} alt={`Extra ${idx+1}`} style={{ width:"100px", height:"100px", objectFit:"cover" }} />
                        ))}
                      </div>
                    )}

                  </div>
                );
              })}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default AdminSellsForm;
